import { ADD_BOOKING, DELETE_BOOKING } from "./actionTypes";

export const addBooking = (data) => {
  return {
    type: ADD_BOOKING,
    payload: data,
  };
};

export const deleteBooking = (id) => {
  return {
    type: DELETE_BOOKING,
    payload: id,
  };
};
